import { Info } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    px: 2,
    py: 1,
    borderRadius: 1,
    backgroundColor: 'info.600',
    color: 'neutral.800',
  },
  icon: {
    mr: 2,
    color: 'inherit',
  },
  text: {
    typography: {
      xs: 'caption',
      sm: 'body3',
    },
  },
};

const Hint = ({ text }: { text: string }) => (
  <Box sx={styles.root}>
    <Info sx={styles.icon} />
    <Typography sx={styles.text}>{text}</Typography>
  </Box>
);

export default Hint;
